import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

export default function DashboardSkeleton() {
  return (
    <Box sx={{ p: 3, width: '100%' }}>
      {/* Header Skeleton */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Skeleton variant="text" width={200} height={40} />
          <Skeleton variant="text" width={150} height={20} />
        </Box>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Skeleton variant="circular" width={40} height={40} />
          <Skeleton variant="circular" width={40} height={40} />
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Skeleton variant="circular" width={40} height={40} />
            <Box>
              <Skeleton variant="text" width={100} height={20} />
              <Skeleton variant="text" width={80} height={15} />
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Main Content Skeleton */}
      <Stack spacing={4}>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '11fr', md: '1fr 1fr 1fr' }, gap: 3 }}>
          <Skeleton variant="rectangular" height={150} sx={{ borderRadius: '16px' }} />
          <Skeleton variant="rectangular" height={150} sx={{ borderRadius: '16px' }} />
          <Skeleton variant="rectangular" height={150} sx={{ borderRadius: '16px' }} />
        </Box>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '11fr', md: '2fr 1fr' }, gap: 3 }}>
          <Skeleton variant="rectangular" height={400} sx={{ borderRadius: '16px' }} />
          <Skeleton variant="rectangular" height={400} sx={{ borderRadius: '16px' }} />
        </Box>
      </Stack>
    </Box>
  );
}
